/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import DocAccessibilityForm from "../../components/DocAccessibilityForm";
import DocList from "../../components/DocAccessList";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import HelperAccordion from "../../components/helperAccordion";
import SideBar from "../../components/Sidebar";
import { GET_ALL_ACCESSIBLE_MEDIA } from "../../utils/constants";
import { makeAuthenticatedGet } from "../../utils/fetchUtils";
import {  mediaData } from "../../utils/types";
import useWindowWidth from "../../utils/windowWidth";

function AVAccess() {
  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const location = useLocation();

  const [media, setMedia] = useState<mediaData[]>([]);
  const [page , setPage] = useState(1);
  const [limit , setLimit] = useState(5);
  const [message , setMessage] = useState('');
  const [totalPages,setTotalPages] = useState(1);
  const [searchText,setSearchText] = useState("");

  const handleLinkClick = () => {
    //setActiveLink("File Upload");
    navigate("/avaccess/new");
  };

  const focusAccessibilityMenu = () => {
    console.log("shifting focus")
    if (menuRef.current) {
      menuRef.current.focus();
    }
  };

  function handleSearchText(event: any): void {
    setSearchText(event.target.value);
  }

  function handleSearchSubmit(event: any): void {
    event.preventDefault();
    console.log(searchText);
    const searchMedia = media.filter((med)=> {
      return (med.fileName.includes(searchText) || med.tag.includes(searchText));
    });
    setMedia(searchMedia);
  }

  const toggleToConvertDoc = ()=> {
    navigate('/avaccess/new');
  }

  const fetchMedia = async ()=> {
    try {
      const url = GET_ALL_ACCESSIBLE_MEDIA + `?page=${page}&limit=${limit}`;
      const response = await makeAuthenticatedGet(url);
      const temp = response;
      console.log("media",temp);
      setMedia(temp.documents);
      setTotalPages(Math.floor((temp.totalBooks - 1) / limit) + 1);
      
      
    } catch (error:any) {
      if(error.response && error.response.data)
      {
        
        setMessage(error.response.data.message);
      }
      console.error("Error fetching books: ", error);
    }
  }

  useEffect(()=>{
    if(localStorage.getItem('token')===null || localStorage.getItem('token')===undefined){
        navigate('/login');
      }
    document.title = 'Audio Video Accessibility - Nclude Portal'
    fetchMedia();

    const intervalId = setInterval(fetchMedia, 0.5 * 60 * 1000);  // Set up an interval to call fetchDocs every 15 minutes

    return () => clearInterval(intervalId);  // Clean up the interval on component unmount
  },[])

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  
//window size
const windowWidth = useWindowWidth();
const isMobile = windowWidth < 769;
  

  return (
    <div className="containerr">
      {" "}
      {/* Fixed typo in className from 'containerr' to 'container' */}
      {!isMobile && <Header activePage='av' curr={1} menuRef={menuRef}/>}
      <div className="page-container">
        <SideBar activePage="avAccessibility"/>
        {isMobile && <header className="mobile-header">
      <div className="accessibility-header" id="accessibility-menu" tabIndex={-1}>
        <button type="button" tabIndex={0}  onClick={()=> toggleToConvertDoc()}>{'Convert Media'}</button>
        <button type="button" tabIndex={0} className="active-accessibility-header">Previous Requests</button>
      </div>  
    </header>}
        <main className="doc-container" role="main" tabIndex={-1} style={{ paddingTop: isMobile?"2rem":""}}>
          {" "}
          {/* Added main tag for semantic HTML structure */}
          <h1 className="display-title" ref={mainRef} tabIndex={-1}>
            {" "}
            {/* Changed h2 to h1 for the main heading of the page */}
            Previous Requests
          </h1>
          {/* <div className="d-flex justify-content-between">
            <HelperAccordion val="av" />
            <button
              className="try-doc-access btn"
              onClick={handleLinkClick}
              aria-label="Convert audio or video"
            >
              Convert audio/video
            </button>
          </div> */}
          <section>
          <a className="sr-only"
             tabIndex={0}
            href="#accessibility-menu"
            >To move to audio-video accessibility menu press enter</a>
            {/* <h2>Previous Requests</h2>{" "} */}
            {/* Changed h3 to h2 to maintain hierarchical structure */}
            <section className="search-div">
              <form className="d-flex search-form" role="search" onSubmit={handleSearchSubmit}>
                <label htmlFor="searchInput" className="visually-hidden" id="search-label">
                  Search document name or tags
                </label>
                <input
                  id="searchInput"
                  className="form-control me-2 search-input"
                  type="search"
                  placeholder="Search document name or tags..."
                  aria-label="Search document name or tags"
                  aria-labelledby="search-label"
                  value={searchText}
                  onChange={handleSearchText}
                />
                <button className="btn search-btn" type="submit" aria-label="search media">
                  Search
                </button>
              </form>
            </section>
          </section>
          <div className="component-container">
            <DocList docList={media}/>
          </div>
        </main>
      </div>
    </div>
  );
}

export default AVAccess;
